import { Flex, FlexProps, Skeleton, Text } from '@chakra-ui/react';
import isNil from 'lodash/isNil';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { GroupPanel } from '@/components/ui/shared/panels/GroupPanel/GroupPanel';
import { ThinSubject } from '@/resources/ThinSubject';

import { LectureGroupAction } from './LectureCount';

interface ISubjectSectionHeaderProps extends FlexProps {
  subject: ThinSubject;
  totalCount: number;
}

export const SubjectSectionHeader: FC<ISubjectSectionHeaderProps> = ({ subject, totalCount }) => {
  const { t } = useTranslation();

  const viewAllURL = `/library/search?subject_subtree_of_id=${subject?.id}`;

  if (!subject) {
    return (
      <Flex h="full" direction="row" justifyContent="space-between">
        <Skeleton h="32px" flex="1" mr="10px" />
        <Skeleton h="32px" flex="1" />
      </Flex>
    );
  }

  return (
    <GroupPanel
      heading={t('library.browseSubject', { name: subject.name })}
      subheading={
        <Text display={{ base: 'block', lg: 'none' }}>{t('library.videoWithCount', { count: totalCount })}</Text>
      }
      action={
        <Skeleton isLoaded={!isNil(totalCount)} minW={{ base: 0, lg: '180px' }} h="32px">
          <LectureGroupAction count={totalCount} href={viewAllURL} />
        </Skeleton>
      }
    ></GroupPanel>
  );
};
